var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35156 6.50391C5.02344 6.85938 4.44922 6.85938 4.12109 6.50391L1.93359 4.31641C1.57812 3.98828 1.57812 3.41406 1.93359 3.08594C2.26172 2.73047 2.83594 2.73047 3.16406 3.08594L4.72266 4.64453L8.49609 0.898438C8.82422 0.542969 9.39844 0.542969 9.72656 0.898438C10.082 1.22656 10.082 1.80078 9.72656 2.12891L5.35156 6.50391ZM5.35156 12.6289C5.02344 12.9844 4.44922 12.9844 4.12109 12.6289L0.621094 9.12891C0.265625 8.80078 0.265625 8.22656 0.621094 7.89844C0.949219 7.54297 1.52344 7.54297 1.85156 7.89844L4.72266 10.7695L11.1211 4.39844C11.4492 4.04297 12.0234 4.04297 12.3516 4.39844C12.707 4.72656 12.707 5.30078 12.3516 5.62891L5.35156 12.6289Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/doubleArrow.bb88d6d19d01b033504d1637e7df5f25.svg";
export { ForwardRef as ReactComponent };